<div id="selection-popup" class="warning-popup">
    <h2 class="m-b-5" mat-dialog-title>Motivo</h2>
    <div mat-dialog-content id="leave-popup-fields">
        <div>
            <form [formGroup]="form">
                <mat-form-field floatLabel="always">
                    <input matInput type="text" formControlName="motivo" maxlength="50" />
                    <mat-hint align="end">{{form.get('motivo').value?.length || 0}}/50</mat-hint>
                    <mat-error *ngIf="form.get('motivo').touched && form.get('motivo').hasError('required')">
                        Obligatorio
                    </mat-error>
                </mat-form-field>
            </form>
        </div>
        <div class="text-a-r p-t-5">
            <button mat-raised-button color="accent" class="m-r-15" (click)="OnEliminarButtonClick()">Eliminar</button>
            <button mat-raised-button color="warn" (click)="Close()">Cancelar</button>
        </div>
    </div>
</div>